import React from 'react'
import styled from 'styled-components'
import AppModal from '../Modal/AppModal'
import { AccentButton } from '../Button/AccentButton'

type Props = {
  open: boolean
  title: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  loadingLabel?: string
  confirmVariant?: 'accent' | 'danger'
  isLoading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

type BodyProps = Omit<Props, 'open' | 'title'>

const ConfirmBody = ({
  message,
  confirmLabel = 'מחק',
  cancelLabel = 'ביטול',
  loadingLabel = 'מוחק...',
  confirmVariant = 'danger',
  isLoading,
  onConfirm,
  onCancel,
}: BodyProps) => (
  <Wrapper>
    <Message>{message}</Message>
    <Footer>
      <AccentButton
        type="button"
        variant={confirmVariant}
        fullWidth={false}
        onClick={onConfirm}
        disabled={isLoading}
      >
        {isLoading ? loadingLabel : confirmLabel}
      </AccentButton>
      <AccentButton
        type="button"
        variant="ghost"
        fullWidth={false}
        onClick={onCancel}
        disabled={isLoading}
      >
        {cancelLabel}
      </AccentButton>
    </Footer>
  </Wrapper>
)

const ConfirmDialog = ({ open, title, onCancel, ...bodyProps }: Props) => {
  if (!open) return null

  return (
    <AppModal
      title={title}
      controlFunc={onCancel}
      Children={ConfirmBody}
      childrenProps={{ ...bodyProps, onCancel }}
      size="sm"
    />
  )
}

export default ConfirmDialog

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`

const Message = styled.p`
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.ink2};
  text-align: start;
`

const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 0.5rem;

  button {
    min-width: 8rem;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    button {
      flex: 1;
      min-width: 0;
    }
  }
`
